import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  gap: 5px;\n  padding: 0px 10px; \n  border: 1px solid ",
        ";\n  margin-top: 10px;\n  margin-left: 10px;\n  ",
        " {\n    gap: 30px;\n    height: 60px;\n    margin-top: 16px;\n    border-radius: 20px;\n    padding: 0px 20px; \n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  justify-content: center;\n  width: 100%;\n  height: 40px;\n  box-shadow: ",
        ";\n  padding: 4px;\n  svg {\n    width: 24px;\n    height: 24px;\n  }\n  div {\n    a {\n      svg {\n        width: 24px;\n        height: 24px;\n      }\n    }\n  }\n  ",
        " {\n    svg {\n      width: 32px;\n      height: 32px;\n    }\n    div {\n      a {\n        svg {\n          width: 32px;\n          height: 32px;\n        }\n      }\n    }\n    height: 60px;\n    padding: 15px 0px; \n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  text-align: right;\n  text-wrap: nowrap;\n  leading-trim: both;\n  text-edge: cap;\n  font-family: Syncopate;\n  margin-left: 4px;\n  margin-right: 4px;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 100%; /* 18px */\n  letter-spacing: -0.54px;\n  text-transform: uppercase;\n  ",
        " {\n    font-size: 18px;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  background-color: var(--colors-gradientBubblegum);\n  backdrop-filter: blur(24px);\n  transform: translate3d(0, 0, 0);\n  @media (min-width: 852px) {\n\n  padding-left: 8px;\n  padding-right: 8px;\n\n  ",
        " {\n    height: ",
        "px;\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  position: sticky;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  // height: ",
        ";\n  height: ",
        "px;\n  width: 100%;\n  z-index: 20;\n\n  ",
        " {\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState } from "react";
import styled, { useTheme } from "styled-components";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import Flex from "../../components/Box/Flex";
import Footer from "../../components/Footer";
import MenuItems from "../../components/MenuItems/MenuItems";
import { useMatchBreakpoints } from "../../contexts";
import Logo from "./components/Logo";
import { MENU_HEIGHT, MOBILE_MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import { MenuContext } from "./context";
import { Text } from "../../components/Text";
import Area51Logo from "../../components/Svg/Icons/Area51";
var Wrapper = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-0"
})(_templateObject());
var StyledLogoContainer = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.inputBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
});
var StyledLogoButton = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-2"
})(_templateObject2(), function(param) {
    var isActive = param.isActive, theme = param.theme;
    return isActive ? "0px -1px 0px 0px ".concat(theme.colors.alienPurple, " inset") : "none";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
});
var StyledLogoText = styled(Text).withConfig({
    componentId: "sc-a5a9d6ea-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
});
var StyledNav = styled.nav.withConfig({
    componentId: "sc-a5a9d6ea-4"
})(_templateObject4(), MOBILE_MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, MENU_HEIGHT);
var FixedContainer = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-5"
})(_templateObject5(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, MOBILE_MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xxl;
}, MENU_HEIGHT);
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-6"
})(_templateObject6(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-a5a9d6ea-7"
})(_templateObject7());
var Inner = styled.div.withConfig({
    componentId: "sc-a5a9d6ea-8"
})(_templateObject8());
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, banner = param.banner, rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isMd = ref.isMd, isSm = ref.isSm;
    var ref1 = useState(true), showMenu = ref1[0], setShowMenu = ref1[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    // const totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    var totalTopMenuHeight = MENU_HEIGHT;
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    // Find the home link if provided
    var homeLink = links === null || links === void 0 ? void 0 : links.find(function(link) {
        return (link === null || link === void 0 ? void 0 : link.label) === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    var theme = useTheme();
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(FixedContainer, {
                    showMenu: showMenu,
                    height: totalTopMenuHeight,
                    children: /*#__PURE__*/ _jsxs(StyledNav, {
                        children: [
                            /*#__PURE__*/ _jsxs(Flex, {
                                children: [
                                    /*#__PURE__*/ _jsxs(StyledLogoContainer, {
                                        children: [
                                            /*#__PURE__*/ _jsxs(StyledLogoButton, {
                                                as: "a",
                                                href: "https://app.alienbase.xyz",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Logo, {
                                                        isActive: false,
                                                        isDark: isDark,
                                                        href: "/swap" /* {homeLink?.href ?? "/"} */ 
                                                    }),
                                                    /*#__PURE__*/ _jsx(StyledLogoText, {
                                                        style: {
                                                            color: theme.colors.textSubtle
                                                        },
                                                        children: "Alienbase"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(StyledLogoButton, {
                                                isActive: true,
                                                as: "a",
                                                href: "/swap",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Area51Logo, {}),
                                                    /*#__PURE__*/ _jsx(StyledLogoText, {
                                                        children: "Area 51"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isMobile && !isSm && /*#__PURE__*/ _jsx(MenuItems, {
                                        items: links,
                                        activeItem: activeItem,
                                        activeSubItem: activeSubItem,
                                        ml: "24px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Flex, {
                                mt: "10px",
                                alignItems: "center",
                                height: "100%",
                                children: rightSide
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(BodyWrapper, {
                    mt: "0",
                    children: /*#__PURE__*/ _jsxs(Inner, {
                        isPushed: false,
                        showMenu: showMenu,
                        children: [
                            children,
                            /*#__PURE__*/ _jsx(Footer, {
                                items: footerLinks,
                                isDark: isDark,
                                toggleTheme: toggleTheme,
                                langs: langs,
                                setLang: setLang,
                                currentLang: currentLang,
                                cakePriceUsd: cakePriceUsd,
                                buyCakeLabel: buyCakeLabel,
                                mb: [
                                    "".concat(MOBILE_MENU_HEIGHT, "px"),
                                    null,
                                    "0px"
                                ]
                            })
                        ]
                    })
                }),
                isMobile && /*#__PURE__*/ _jsx(BottomNav, {
                    items: links,
                    activeItem: activeItem === undefined ? "/swap" : activeItem,
                    activeSubItem: activeSubItem
                })
            ]
        })
    });
};
export default Menu;
